/* src/app/components/billing/reports/ignored-timesheet-report/ignored-timesheet-report.component.css */
.report-container {
  display: flex;
  margin: 16px;
  width: 100%;
}
.report-label {
  margin-bottom: 4px;
  font-weight: 600;
  width: 100%;
}
.chart-info-container {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  width: 100%;
  flex-wrap: wrap;
}
#chart {
  width: 58%;
}
.detailed-data-container {
  width: 40%;
}
@media (max-width: 768px) {
  .chart-info-container {
    flex-direction: column;
  }
  #chart,
  .detailed-data-container {
    width: 100%;
  }
}
:host ::ng-deep .apexcharts-legend {
  top: 56px !important;
}
.radio-group-container {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=ignored-timesheet-report.component-XHYYHXJ4.css.map */
